import PeriodSummary from '../PeriodSummary';

type PeriodSummarySectionProps = {
  periods: { start: string; end: string }[];
  holidayDates: Map<string, string>;
  workWeek: 'five' | 'six';
};

export function PeriodSummarySection({ periods, holidayDates, workWeek }: PeriodSummarySectionProps) {
  return (
    <div className="sticky top-0 z-20 mt-3 sm:mt-2 px-2 sm:px-0">
      <div className="sm:block hidden">
        <PeriodSummary periods={periods} holidayDates={holidayDates} workWeek={workWeek} />
      </div>
      <div className="sm:hidden block text-sm leading-tight py-2 px-3 bg-green-100 text-green-900 rounded-lg shadow-sm font-semibold text-center">
        <PeriodSummary periods={periods} holidayDates={holidayDates} workWeek={workWeek} />
      </div>
    </div>
  );
}
